import {http} from '../utils'

// 营销短信模板 start
// 查询
const searchAction = (params) => {
  const url = `/market/management/task/page`
  return http.post(url, params)
}
// 获取status列表
const getStatus = (type) => {
  const url = `/market/common/codeList/${type}`
  return http.post(url)
}
// 获取group列表
const getGroup = (params) => {
  const url = '/market/management/group/all'
  return http.post(url, params)
}
// 获取sign列表
const getSign = (params) => {
  const url = '/market/management/sign/all'
  return http.post(url, params)
}
// 获取getResourcePool列表
const getResourcePool = (params) => {
  const url = '/market/management/resource/all'
  return http.post(url, params)
}
// 获取 详情
const getAction = (id) => {
  const url = `/market/management/task/detail/${id}`
  return http.post(url)
}
// 新建
const addAction = (params) => {
  const url = `/market/management/task/save`
  return http.post(url, params)
}
// 同意 拒绝
const agreeAction = (params) => {
  const url = `/market/management/task/approve`
  return http.post(url,params)
}
// 同步
const syncAction = () => {
  const url = '/market/management/task/sync'
  return http.post(url)
}
// 生成ID
const generateIDAction = (params) => {
  const url = `/market/common/generateID`
  return http.post(url, params)
}
// 查询
const phoneAction = (params) => {
  const url = `/market/management/phone/list`
  return http.post(url, params)
}
// 添加号码
const addPhoneAction = (params) => {
  const url = `/market/management/phone/add`
  return http.post(url, params)
}
// 清空号码
const clearPhoneAction = (params) => {
  const url = `/market/management/phone/delete`
  return http.post(url, params)
}
// 个性短信预览时生产短信内容并分页返回数据
const selfAction = (params) => {
  const url = `/market/management/view/content`
  return http.post(url, params)
}
// 个性短信Excel预览
const excelViewAction = (params) => {
  const url = `/market/management/excel/view`
  return http.post(url, params)
}
// 删除
const deleteAction = (id) => {
  const url = `/market/management/task/delete/${id}`
  return http.post(url)
}
// 获取手机号统计结果
const statisticsAction = (params) => {
  const url = `/market/management/task/phone/statistics`
  return http.post(url, params)
}
// 获取短信余额
const smsBalance = (params) => {
  const url = `/market/management/group/sms/balance`
  return http.post(url, params)
}
// 重新发送
const reSendAction = (params) => {
  const url = `/market/management/task/reSend`
  return http.post(url, params)
}
// 展会届次列表
const expoAction = (params) => {
  const url = `/market/common/resume`
  return http.post(url, params)
}

// 发送测试短信
const sendTestPhone=(params)=>{
  const url = `/market/management/sms/send/test`
  return http.post(url,params)
}

export default {
  searchAction,
  getStatus,
  getGroup,
  getSign,
  getResourcePool,
  getAction,
  addAction,
  agreeAction,
  syncAction,
  generateIDAction,
  phoneAction,
  addPhoneAction,
  clearPhoneAction,
  selfAction,
  excelViewAction,
  deleteAction,
  statisticsAction,
  smsBalance,
  reSendAction,
  expoAction,
  sendTestPhone
}
